import { Check, X } from "lucide-react";

const rows = [
  { feature: "GAF Master Elite Certified", us: true, them: false },
  { feature: "Licensed & Insured", us: true, them: "Varies" },
  { feature: "Lifetime Workmanship Warranty", us: true, them: false },
  { feature: "50-Year GAF System Plus Warranty", us: true, them: false },
  { feature: "$0 Down Financing", us: true, them: false },
  { feature: "24/7 Emergency Service", us: true, them: false },
  { feature: "Free Drone Inspection", us: true, them: false },
  { feature: "In Business Since 2007", us: true, them: "Unknown" },
];

export const AdsComparisonTable = () => (
  <section className="py-16 bg-muted">
    <div className="container mx-auto px-4 max-w-3xl">
      <h2 className="text-3xl font-extrabold text-center text-foreground mb-2">
        Why Choose <span className="text-primary">Safeway</span>?
      </h2>
      <p className="text-center text-muted-foreground mb-10">
        See how we stack up against the competition.
      </p>

      <div className="bg-background rounded-2xl shadow-lg overflow-hidden">
        {/* Header */}
        <div className="grid grid-cols-3 text-center text-sm font-bold border-b border-border">
          <div className="p-4 text-left text-muted-foreground">Feature</div>
          <div className="p-4 bg-primary/5 text-primary">Safeway</div>
          <div className="p-4 text-muted-foreground">Others</div>
        </div>
        {rows.map((row, i) => (
          <div key={row.feature} className={`grid grid-cols-3 text-center text-sm ${i % 2 === 0 ? "" : "bg-muted/40"}`}>
            <div className="p-4 text-left font-medium text-foreground">{row.feature}</div>
            <div className="p-4 bg-primary/5 flex justify-center">
              {row.us === true ? (
                <Check className="w-5 h-5 text-primary" />
              ) : (
                <span className="text-muted-foreground">{String(row.us)}</span>
              )}
            </div>
            <div className="p-4 flex justify-center">
              {row.them === false ? (
                <X className="w-5 h-5 text-destructive" />
              ) : (
                <span className="text-muted-foreground text-xs">{String(row.them)}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
